import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import React from 'react';

import { CardSkeleton } from '../Card';

const useResultsPlaceholderStyles = makeStyles({
  root: {
    width: '100%',
    gap: '30px',
    display: 'grid',
  },
  grid: {
    gridTemplateColumns: '1fr 1fr 1fr',
  },
  row: {
    gridTemplateColumns: '1fr',
  },
});

export const ResultsPlaceholder = ({
  theme,
  cardColor,
  itemCount = 3,
  row,
}: PropsWithTheme<any>) => {
  const classes = useResultsPlaceholderStyles();
  return (
    <div className={clsx(classes.root, row ? classes.row : classes.grid)}>
      {[...Array(itemCount)].map(() => (
        <CardSkeleton image theme={theme} cardColor={cardColor} animated={false} row={row} />
      ))}
    </div>
  );
};
